import TermoAceite from "./termoAceite";
import {
  Divider,
  Modal,
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Backdrop,
} from "@mui/material";
import register from "../../../assets/register.json";
import Lottie from "lottie-react";

function ModalAceiteContrato({
  confirmacao,
  openModal,
  closeModal,
  confirmar,
  confirmarEmail,
  setConfirmarEmail,
  setConfirmar,
  largura,
  loading,
}) {
  const style = {
    modal: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: largura < 950 ? "100%" : 900,
      height: 600,
      bgcolor: "background.paper",
      border: "1px solid #090909",
      borderRadius: 4,
      boxShadow: 24,
      overflowY: "scroll",
      fontSize: 14,
      p: 4,
    },
  };

  return (
    <Modal open={openModal}>
      <>
        <Box sx={style.modal}>
          {loading && (
            <Backdrop
              style={{ color: "#FFFFFF", background: "rgba(0,0,0,0.70)" }}
              open={true}
            >
              <div style={{ fontSize: 20, textAlign: "center" }}>
                <b>Aguarde!</b> <br />
                estamos finalizando seu cadastro!
                <Lottie
                  animationData={register}
                  style={{ width: 200, margin: "auto" }}
                />
              </div>
            </Backdrop>
          )}
          <TermoAceite />
          <Divider style={{ margin: "15px 0px 15px 0px" }} />
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  color="primary"
                  checked={confirmar}
                  onChange={() => setConfirmar(!confirmar)}
                />
              }
              label=" Declaro que li e concordo com as informações acima."
            />
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  color="primary"
                  checked={confirmarEmail}
                  onChange={() => setConfirmarEmail(!confirmarEmail)}
                />
              }
              label="Autorizo o envio de email."
            />
          </FormGroup>
          <div style={{ float: "right" }}>
            <button
              disabled={confirmar ? false : true}
              onClick={confirmacao}
              style={{
                padding: "0.7em 1.8em",
                border: confirmar ? "1px #117045 solid" : "none",
                borderRadius: "4px",
                background: confirmar ? "#fff" : "",
                color: confirmar ? "#117045" : "",
                cursor: "pointer",
                fontWeight: "bold",
              }}
            >
              Contratar
            </button>
            <button
              onClick={closeModal}
              style={{
                padding: "0.7em 1.8em",
                border: "1px #b52430 solid",
                borderRadius: "4px",
                background: "#fff",
                color: "#b52430",
                cursor: "pointer",
                fontWeight: "bold",
                marginLeft: "12px",
              }}
            >
              Fechar
            </button>
          </div>
        </Box>
      </>
    </Modal>
  );
}

export default ModalAceiteContrato;
